import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Spin } from '@douyinfe/semi-ui';
import { useAutoTheme } from './context/Theme';
import Home from './pages/Home';
import LogsTable from './components/LogsTable';
import BalanceTransfer from './components/BalanceTransfer';
import ClaudeDocs from './components/ClaudeDocs';

function App() {
    const { theme } = useAutoTheme();
    const [iframeLoading, setIframeLoading] = useState(true);

    // 服务状态页面 - 由于 X-Frame-Options 限制，使用重定向
    const StatusPage = () => {
        window.location.href = 'https://status.wyzlab.ai/';
        return (
            <div className="status-redirect">
                <Spin size="large" />
                <p>正在跳转到服务状态页面...</p>
                <style>{`
                    .status-redirect {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        height: calc(100vh - 60px);
                        gap: 16px;
                    }
                `}</style>
            </div>
        );
    };

    // 改进版 iframe - 隐藏导航栏，全屏融合
    const pricingIframeSrc = 'https://shell.wyzlab.ai/pricing';
    const PricingPage = () => (
        <div className="pricing-iframe-wrapper">
            {iframeLoading && (
                <div className="pricing-iframe-loading">
                    <Spin size="large" />
                    <p>加载中...</p>
                </div>
            )}
            <div className="pricing-iframe-container">
                <iframe
                    src={pricingIframeSrc}
                    title="模型价格"
                    className="pricing-iframe-seamless"
                    onLoad={() => setIframeLoading(false)}
                />
            </div>
            <style>{`
                .pricing-iframe-wrapper {
                    position: relative;
                    width: 100%;
                    height: calc(100vh - 60px);
                    overflow: hidden;
                    background: var(--semi-color-bg-0);
                }
                .pricing-iframe-loading {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 16px;
                    z-index: 10;
                }
                .pricing-iframe-container {
                    width: 100%;
                    height: calc(100% + 64px);
                    margin-top: -64px;
                    overflow: hidden;
                }
                .pricing-iframe-seamless {
                    width: 100%;
                    height: 100%;
                    border: none;
                    background: transparent;
                }
            `}</style>
        </div>
    );

    return (
        <div className={`App-body theme-${theme}`}>
            <div className="page-content">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/query" element={<LogsTable />} />
                    <Route path="/transfer" element={<BalanceTransfer />} />
                    <Route path="/claude-docs" element={<ClaudeDocs />} />
                    <Route path="/pricing" element={<PricingPage />} />
                    <Route path="/status" element={<StatusPage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </div>
        </div>
    );
}

export default App;
